import { render, staticRenderFns } from "./OrganisationSplash.vue?vue&type=template&id=5ca4eba0&scoped=true&"
import script from "./OrganisationSplash.vue?vue&type=script&lang=js&"
export * from "./OrganisationSplash.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSplash.vue?vue&type=style&index=0&id=5ca4eba0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4eba0",
  null
  
)

export default component.exports